<template>
	<div>
		<div class="filter mb-2">
			<div class="w-full rounded-lg flex items-center">
				<div class="w-8/12">
					<h1 class="flex w-full text-xl h-6 mb-4 sm:mb-7 font-extrabold sm:text-2xl">Архив результатов НОК</h1>
				</div>
				<div class="w-4/12 flex items-center justify-end">
					<!-- <Select @input="changeYear(selectedYear)" v-model="selectedYear" :options="years" color="blue" size="small" /> -->
					<div class="w-28 add-form__selectSingle">
						<multiselect
							tag-placeholder=""
							placeholder=""
							:show-labels="false"
							v-model="selectedYear"
							:options="years"
							@input="changeYear(selectedYear)"
							:searchable="false"
							:multiple="false"
						/>
					</div>

					<div class="flex items-center ml-2">
						<button
							type="button"
							class="h-12 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
							@click="openExport = true"
						>
							<!-- eslint-disable max-len -->
							<svg class="-ml-1 mr-2" width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12.4792 9.23315C12.1627 8.92037 11.6526 8.92336 11.3398 9.23982L8.79095 11.8187L6.74934 9.88272C6.42647 9.57656 5.91654 9.5901 5.61037 9.91297C5.30421 10.2358 5.31775 10.7458 5.64062 11.0519L7.65803 12.965L5.53708 15.1109C5.22431 15.4274 5.22729 15.9375 5.54376 16.2503C5.86022 16.563 6.37032 16.56 6.6831 16.2436L8.82749 14.0739L11.7737 16.8677C12.0965 17.1739 12.6065 17.1603 12.9126 16.8374C13.2188 16.5146 13.2052 16.0046 12.8824 15.6985L9.9604 12.9277L12.4858 10.3725C12.7986 10.056 12.7956 9.54593 12.4792 9.23315Z"
									fill="white"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M5.16216 3.31155C6.65305 2.84024 10.3561 1.87381 13.1054 1.87381C14.6049 1.87381 15.6675 2.34124 16.3453 3.06492C16.5018 3.23197 16.6327 3.40746 16.7411 3.58624H17.5425C20.8562 3.58624 23.5425 6.27253 23.5425 9.58624V16.4137C23.5425 19.7274 20.8562 22.4137 17.5425 22.4137H16.1147C15.8915 22.7471 15.63 23.0299 15.34 23.2652C14.4412 23.9941 13.3791 24.1747 12.6449 24.1157L12.626 24.1141L12.6071 24.1118C11.2851 23.9505 7.96744 23.4878 5.25227 22.9224C4.39523 22.744 3.65165 22.5225 3.07624 22.117C2.44619 21.6729 2.10591 21.0755 1.91779 20.352C1.74256 19.6781 1.68604 18.8392 1.64189 17.8518C1.62964 17.5779 1.61829 17.2886 1.60624 16.9811L1.60624 16.981L1.60624 16.981C1.57343 16.1444 1.53537 15.1736 1.45955 14.0154L1.45758 13.9853V7.33013C1.45758 5.94007 1.97059 4.99105 2.79786 4.35764C3.47647 3.83805 4.33303 3.57063 4.99157 3.36503C5.05008 3.34676 5.10704 3.32898 5.16216 3.31155ZM17.1077 8.82927C17.1329 7.60017 17.1569 6.47834 17.1765 5.58624H17.5425C19.7517 5.58624 21.5425 7.3771 21.5425 9.58624V16.4137C21.5425 18.6228 19.7517 20.4137 17.5425 20.4137H16.8514C16.8983 20.1009 16.9244 19.7668 16.9273 19.4106C16.9321 18.7996 16.9416 18.0337 16.9544 17.1706H18.98C19.4179 17.1706 19.773 16.8155 19.773 16.3776V16.3115C19.773 15.8735 19.4179 15.5185 18.98 15.5185H16.9807C16.9899 14.9711 16.9998 14.4034 17.0103 13.8258H18.98C19.4179 13.8258 19.773 13.4708 19.773 13.0328V12.9667C19.773 12.5288 19.4179 12.1737 18.98 12.1737H17.0412C17.052 11.6061 17.0631 11.0388 17.0742 10.4814H18.98C19.4179 10.4814 19.773 10.1263 19.773 9.68835V9.62227C19.773 9.18431 19.4179 8.82927 18.98 8.82927H17.1077ZM13.1054 3.72065C10.6503 3.72065 7.16938 4.61394 5.71884 5.07249L5.63521 5.09892C4.88278 5.33653 4.32879 5.51149 3.92061 5.82402C3.58581 6.08036 3.30442 6.46794 3.30442 7.33013V13.925C3.38066 15.0964 3.4198 16.0946 3.45251 16.929L3.45251 16.929L3.45251 16.929C3.46433 17.2303 3.4753 17.5103 3.48689 17.7693C3.53223 18.7834 3.58647 19.4306 3.7052 19.8872C3.81103 20.2943 3.94792 20.4719 4.14021 20.6074C4.38715 20.7815 4.8111 20.9441 5.62873 21.1144C8.25822 21.6619 11.4981 22.1153 12.8095 22.276C13.1608 22.2999 13.7178 22.203 14.1766 21.8308C14.6072 21.4815 15.0694 20.7941 15.0805 19.3959C15.1063 16.1453 15.2632 8.55726 15.3383 5.17394L15.3385 5.1656L15.3388 5.15725C15.3462 4.97492 15.2767 4.6256 14.9974 4.32745C14.7397 4.05229 14.2081 3.72065 13.1054 3.72065Z"
									fill="white"
								/>
							</svg>
							<!-- eslint-enable max-len -->

							Экспорт в Excel
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="flex flex-col relative">
			<div
				class="t-overflow rounded-t-lg overflow-x-auto h-auto bg-white filter shadow-default"
				:class="{ 'custom-w-table-144': !menu, 'custom-w-table-360': menu }"
				:style="list.length > 9 ? 'height: calc(100vh - 316px)' : ''"
			>
				<table>
					<thead>
						<tr :class="{ tr1__sticky: rowsVisible > 5 }">
							<th
								rowspan="3"
								style="min-width: 50px; max-width: 50px"
								class="sticky-table__header3 text-center border-r border-b border-gray-200 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
							>
								П/П
							</th>
							<th
								:class="{ 'w-32 sticky-table__header1': ind === 0, 'w-32 sticky-table__header2': ind === 1 }"
								rowspan="3"
								class="px-6 py-3 border-b border-r border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
								v-for="(item, ind) in fields_sticky"
								:key="'J' + ind"
							>
								<span class="flex relative">
									<span :class="{ 'border-b border-gray-200 cursor-pointer': ind !== 1, 'text-blue-500 underline': filterBy === ind }" @click="switchFilterVisibility(ind)">
										{{ item.Name }}
									</span>
									<Icons v-if="params.filters.find((f) => f.fieldName === item.fieldName)" icon-name="filter" class="hidden sm:block ml-2" />

									<!-- Фильтр и сортировка -->
									<FilterComponent
										v-on:change="switchFilterVisibility(null)"
										:position="ind === 0 ? 'left' : 'right'"
										:filterOpen="filterOpen"
										:id-filter="ind"
										:param="params"
										@query="getData"
										:fields="fields_sticky"
										:defaultSortField="'RegionName'"
										:item="item"
									/>
								</span>
							</th>
							<th colspan="20" class="px-6 py-3 border-r border-b border-gray-200 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
								Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка
							</th>
						</tr>
						<tr :class="{ tr2__sticky: rowsVisible > 5 }">
							<th
								v-for="(item, ind) in subFields"
								:key="'K' + ind"
								colspan="4"
								class="px-6 py-3 border-r border-b border-gray-200 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ item }}
							</th>
						</tr>
						<tr :class="{ tr3__sticky: rowsVisible > 5 }">
							<th
								v-for="(item, ind) in fields"
								:key="'L' + ind"
								class="px-6 py-3 border-r border-b border-gray-200 text-center leading-4 font-medium text-gray-500 uppercase tracking-wider"
								:class="{ 'bg-lavender': columnHasGeneralIndicator(item) }"
							>
								{{ item }}
							</th>
						</tr>
					</thead>
					<tbody class="bg-white" v-for="(item, indx) in list" :key="'A1' + indx">
						<tr>
							<td rowspan="6" class="sticky-table__row3 px-2 font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								<span v-if="params.currentPage === 0">
									{{ indx + 1 }}
								</span>
								<span v-if="params.currentPage > 0">
									{{ params.currentPage * params.pageSize + (indx + 1) }}
								</span>
							</td>
							<td rowspan="6" class="w-32 sticky-table__row1 px-6 py-4 font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.regionName }}
							</td>
						</tr>
						<tr>
							<td class="sticky-table__row2 px-6 py-4 whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">А</td>

							<td class="px-6 py-4 text-sm text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_Result }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_Count }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_1_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_1_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_1_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_2_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_2_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_2_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_3 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_3_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_3_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_3_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_4 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_4_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_4_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_4_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_5 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_5_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_5_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.a_5_3 }}
							</td>
						</tr>
						<tr>
							<td class="sticky-table__row2 px-6 py-4 whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">С</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_Result }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_Count }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_1_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_1_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_1_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_2_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_2_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_2_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_3 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_3_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_3_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_3_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_4 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_4_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_4_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_4_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_5 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_5_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_5_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.s_5_3 }}
							</td>
						</tr>
						<tr>
							<td class="sticky-table__row2 px-6 py-4 whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">К</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_Result }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_Count }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_1_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_1_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_1_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_2_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_2_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_2_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_3 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_3_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_3_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_3_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_4 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_4_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_4_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_4_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_5 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_5_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_5_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.k_5_3 }}
							</td>
						</tr>
						<tr>
							<td class="sticky-table__row2 px-6 py-4 whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">П</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_Result }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_Count }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_1_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_1_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_1_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_2_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_2_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_2_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_3 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_3_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_3_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_3_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_4 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_4_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_4_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_4_3 }}
							</td>

							<td class="px-6 py-4 text-sm whitespace-no-wrap bg-lavender border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_5 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_5_1 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_5_2 }}
							</td>
							<td class="px-6 py-4 text-sm whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.p_5_3 }}
							</td>
						</tr>
						<tr class="row-total">
							<td class="sticky-table__row2 font-bold px-6 py-4 whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">Итог</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_Result }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_Count }}
							</td>

							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_1 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_1_1 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_1_2 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_1_3 }}
							</td>

							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_2 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_2_1 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_2_2 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_2_3 }}
							</td>

							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_3 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_3_1 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_3_2 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_3_3 }}
							</td>

							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_4 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_4_1 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_4_2 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_4_3 }}
							</td>

							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_5 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_5_1 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_5_2 }}
							</td>
							<td class="px-6 py-4 text-sm font-bold whitespace-no-wrap border-b border-r border-gray-200 leading-5 text-gray-500 text-center">
								{{ item.r_5_3 }}
							</td>
						</tr>
					</tbody>
				</table>
				<center v-if="!loadingTable && list.length === 0" class="w-full py-28 whitespace-no-wrap text-xl leading-5 text-gray-500 text-center">Данных нет...</center>
			</div>
			<!-- Навигация -->
			<div class="h-auto rounded-b-lg bg-white filter shadow-default">
				<div class="hidden sm:flex flex-row pt-6 pl-6 pr-20 pb-12 text-gray-400 text-sm">
					<div class="mr-auto">
						<p>Всего записей: {{ totalRows }}</p>
					</div>
					<div class="flex flex-row ml-auto">
						<p>Строк на странице:</p>
						<ul class="flex flex-row">
							<li @click="updateRow(50)" class="flex ml-4 cursor-pointer" :class="{ 'text-blue-500': rowsVisible == 50 }">50</li>
							<li @click="updateRow(100)" class="flex ml-4 cursor-pointer" :class="{ 'text-blue-500': rowsVisible == 100 }">100</li>
							<li @click="updateRow(200)" class="flex ml-4 cursor-pointer" :class="{ 'text-blue-500': rowsVisible == 200 }">200</li>
							<li @click="updateRow(null)" class="flex ml-4 cursor-pointer" :class="{ 'text-blue-500': rowsVisible == null }">Все</li>
						</ul>
					</div>
					<div class="flex flex-row ml-24">
						<ul class="flex flex-row">
							<li class="flex ml-4 cursor-pointer arrow" @click="page !== 0 ? navigation('params', page - 1) : ''" />
							<li class="flex">
								<span>Стр</span>
								<b class="ml-2">{{ page + 1 }}</b>
								<span class="ml-2">из</span>
								<b class="ml-2">{{ totalCount === 0 ? 1 : totalCount }}</b>
							</li>
							<li class="flex ml-2 cursor-pointer arrow" @click="page + 1 < totalCount ? navigation('params', page + 1) : ''" />
						</ul>
					</div>
				</div>
			</div>

			<div v-if="loadingTable" class="absolute w-full h-full preloader rounded-lg">
				<loadingComponent class="absolute top-1/2 left-1/2" />
			</div>
		</div>

		<PopUp :open="openExport" size="700px" title="Выберите поля для экспорта" @close="closeOpenExport">
			<div class="t-overflow flex flex-col overflow-auto" style="height: 850px">
				<CheckboxGroup :options="fieldsDownloadExcell" :disabled="false" />
			</div>
			<div class="flex mt-5 justify-end">
				<Button size="smoll" class="mr-3" text="Экспорт" :load="loadToExcell" :disabled="loadToExcell" @click.native="downloadExcell(params, fieldsDownloadExcell)" />
				<Button size="smoll" color="white" text="Закрыть" @click.native="closeOpenExport()" />
			</div>
		</PopUp>
	</div>
</template>

<script>
import debounce from 'lodash.debounce';
// Глобальные данные стора
import { getters, mutations, actions } from '@/store/store';
// Локальные данные стора
import actionsL from '../store/actions';
import loadingComponent from '@/components/Loading.vue';
// import Select from '@/components/Select.vue';
import Multiselect from 'vue-multiselect';
// import FilterComponent from '@/components/Filter.vue';
import Icons from '@/components/Icons.vue';
import Button from '@/components/Button.vue';
import PopUp from '@/components/PopUp.vue';
import CheckboxGroup from '@/components/CheckboxGroup.vue';
import FilterComponent from '@/components/Filter.vue';

export default {
	name: 'TableArchiveNok',
	components: {
		loadingComponent,
		Multiselect,
		Icons,
		PopUp,
		Button,
		CheckboxGroup,
		FilterComponent
		// Select
	},
	computed: {
		...getters
	},
	data() {
		return {
			selectedYear: '2021',
			openExport: false,
			loadingTable: false,
			loadToExcell: false,
			rowsVisible: 100,
			totalRows: 0,
			totalCount: 0,
			page: 0,
			filterOpen: null,
			filterBy: null,
			fields: ['1', '1.1', '1.2', '1.3', '2', '2.1', '2.2', '2.3', '3', '3.1', '3.2', '3.3', '4', '4.1', '4.2', '4.3', '5', '5.1', '5.2', '5.3'],
			subFields: [
				'Открытость и доступность информации об организации',
				'Комфортность условий предоставления услуг, включая время ожидания предоставления медицинской услуги',
				'Доступность услуг для инвалидов',
				'Доброжелательность, вежливость работников медицинской организации',
				'Удовлетворенность условиями оказания услуг'
			],
			fields_sticky: [
				{
					Name: 'Наименование региона',
					fieldName: 'RegionName',
					filterType: 2,
					filterValueType: 1,
					autocomplete: true,
					list: [],
					itemKey: 'Name',
					value1: '',
					value2: null,
					sortBy: null,
					paramsFiter: '',
					label1: 'По возрастанию (А-Я)',
					label2: 'По убыванию (Я-А)'
				},
				{
					Name: 'Условие оказания',
					fieldName: '',
					filterType: 2,
					filterValueType: 1,
					value1: '',
					value2: null,
					sortBy: null,
					paramsFiter: '[0-9.]',
					label1: 'По возрастанию',
					label2: 'По убыванию'
				},
				{
					Name: 'Итоговый результат по условиям оказания',
					fieldName: 'r_Result',
					filterType: 1,
					filterValueType: 2,
					value1: '',
					value2: null,
					sortBy: null,
					paramsFiter: '[0-9.]',
					label1: 'По возрастанию',
					label2: 'По убыванию'
				},
				{
					Name: 'Количество анкет',
					fieldName: 'r_Count',
					filterType: 1,
					filterValueType: 2,
					value1: '',
					value2: null,
					sortBy: null,
					paramsFiter: '[0-9.]',
					label1: 'По возрастанию',
					label2: 'По убыванию'
				}
			],
			fieldsDownloadExcell: [
				{ title: 'Наименование региона', id: 'RegionName', checked: true },
				{ title: 'Условие оказания', id: 'ProvisionCondition', checked: true },
				{ title: 'Итоговый результат по условиям оказания', id: 'TotalResult', checked: true },
				{ title: 'Количество анкет', id: 'SurveysCount', checked: true },
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Открытость и доступность информации об организации: 1',
					id: 'Value_1',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Открытость и доступность информации об организации: 1.1',
					id: 'Value_1_1',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Открытость и доступность информации об организации: 1.2',
					id: 'Value_1_2',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Открытость и доступность информации об организации: 1.3',
					id: 'Value_1_3',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Комфортность условий предоставления услуг, включая время ожидания предоставления медицинской услуги: 2',
					id: 'Value_2',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Комфортность условий предоставления услуг, включая время ожидания предоставления медицинской услуги: 2.1',
					id: 'Value_2_1',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Комфортность условий предоставления услуг, включая время ожидания предоставления медицинской услуги: 2.2',
					id: 'Value_2_2',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Комфортность условий предоставления услуг, включая время ожидания предоставления медицинской услуги: 2.3',
					id: 'Value_2_3',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доступность услуг для инвалидов: 3',
					id: 'Value_3',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доступность услуг для инвалидов: 3.1',
					id: 'Value_3_1',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доступность услуг для инвалидов: 3.2',
					id: 'Value_3_2',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доступность услуг для инвалидов: 3.3',
					id: 'Value_3_3',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доброжелательность, вежливость работников медицинской организации: 4',
					id: 'Value_4',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доброжелательность, вежливость работников медицинской организации: 4.1',
					id: 'Value_4_1',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доброжелательность, вежливость работников медицинской организации: 4.2',
					id: 'Value_4_2',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Доброжелательность, вежливость работников медицинской организации: 4.3',
					id: 'Value_4_3',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Удовлетворенность условиями оказания услуг: 5',
					id: 'Value_5',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Удовлетворенность условиями оказания услуг: 5.1',
					id: 'Value_5_1',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Удовлетворенность условиями оказания услуг: 5.2',
					id: 'Value_5_2',
					checked: true
				},
				{
					title: 'Показатели, характеризующие общие критерии оценки качества условий оказания услуг медицинскими организациями, в отношении которых проводится независимая оценка: Удовлетворенность условиями оказания услуг: 5.3',
					id: 'Value_5_3',
					checked: true
				}
			],
			sortAsc: 2,
			sortDesc: 1,
			list: [],
			defaultSortField: 'RegionName',
			params: {
				filters: [],
				sortOption: {
					fieldName: '',
					sortType: null
				},
				pageSize: 100,
				currentPage: 0
			},
			years: []
		};
	},
	methods: {
		...mutations,
		...actionsL,
		getRegions: actions.getRegions,
		switchFilterVisibility(key) {
			// если это не колонка условие оказания
			if (key !== 1) {
				this.filterOpen = this.filterOpen === key ? null : key;
				this.filterBy = key;
			}
		},
		updateRow(rowsVisible) {
			this.rowsVisible = rowsVisible;
			this.params.pageSize = rowsVisible;
			this.getData(this.params, true);
		},
		sortFilter(key, flag, fieldName) {
			for (let i = 0; i < this.fields_sticky.length; i += 1) {
				if (flag) {
					if (key === i) {
						this.fields_sticky[i].value1 = '';
						this.fields_sticky[i].sortBy = null;

						if (this.params.sortOption.fieldName === fieldName) {
							this.resetSort();
						}

						const index = this.params.filters.findIndex((f) => f.fieldName === fieldName);
						if (index >= 0) this.params.filters.splice(index, 1);

						break;
					}
				}

				if (key === i) {
					this.params.sortOption.sortType = this.fields_sticky[i].sortBy;
				}
			}
			if (!flag) {
				this.params.sortOption.fieldName = fieldName;
			}

			this.getData(this.params, true);

			this.switchFilterVisibility(null);
		},
		resetSort() {
			let sortField = this.fields_sticky.find((x) => x.fieldName === this.defaultSortField);

			if (sortField !== undefined) {
				sortField.sortBy = this.sortAsc;
				this.params.sortOption.sortType = sortField.sortBy;
				this.params.sortOption.fieldName = sortField.fieldName;
			}
		},
		search: debounce(function (item, array) {
			// если дата
			if (item.filterType === 3) {
				let dateStart = new Date(item.value1),
					it = item;
				it.value2 = new Date(dateStart.setDate(dateStart.getDate() + 1)).toISOString().substr(0, 10);
			}

			let obj = array.find((f) => f.fieldName === item.fieldName);

			if (array.length === 0 || !obj) {
				array.push(item);
			} else if (obj) {
				obj.value1 = item.value1;
			}

			for (let i = 0; i < this.params.filters.length; i += 1) {
				if (!this.params.filters[i].value1) {
					this.params.filters.splice(i, 1);
				}
			}

			this.getData(this.params, true);

			this.switchFilterVisibility(null);
		}, 1000),
		getData(params, flag) {
			this.loadingTable = true;
			// если фильтруем/сортируем то возвращаем пагинацию на 1 страницу
			if (flag) {
				this.params.currentPage = 0;
				this.page = 0;
			}

			this.get({
				filters: [
					...params.filters,
					{
						fieldName: 'YearStr',
						filterType: 2,
						filterValueType: 1,
						value1: this.selectedYear
					}
				],
				sortOption: {
					fieldName: params.sortOption.fieldName,
					sortType: params.sortOption.sortType
				},
				pageSize: params.pageSize,
				currentPage: params.currentPage
			}).then((res) => {
				this.loadingTable = false;
				this.list = res.data.data;
				this.adjustSort(this.list, params);
				this.totalRows = res.data.totalRecords;
				this.totalCount = this.rowsVisible ? Math.ceil(res.data.totalRecords / this.rowsVisible) : 1;
			});
		},
		adjustSort(list, params) {
			if (params.sortOption.fieldName === 'RegionName') {
				let index = list.findIndex((x) => x.regionName.includes('Федеральные'));

				if (index > 0) {
					let item = list[index];
					list.splice(index, 1);
					list.unshift(item);
				}
			}
		},
		navigation(name, page) {
			this.page = page;
			this[name].currentPage = page;

			this.getData(this[name], false);
		},
		downloadExcell(params, fieldsDownloadExcell) {
			this.loadToExcell = true;
			let columnList = fieldsDownloadExcell.filter((f) => f.checked).map((m) => m.id);

			this.$http
				.post(
					'MedicalOrgs/GetResultForYearExcelByRegion',
					{
						filters: [
							...params.filters,
							{
								fieldName: 'YearStr',
								filterType: 2,
								filterValueType: 1,
								value1: this.selectedYear
							}
						],
						sortOption: {
							fieldName: params.sortOption.fieldName,
							sortType: params.sortOption.sortType
						},
						pageSize: params.pageSize,
						currentPage: params.currentPage,
						columns: columnList
					},
					{
						responseType: 'blob',
						headers: {
							'Access-Control-Expose-Headers': 'Content-Disposition'
						}
					}
				)
				.then((res) => {
					let fileNameAndType = decodeURI(res.headers['content-disposition'].split('filename*=')[1].split("''")[1]);

					const url = window.URL.createObjectURL(new Blob([res.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', fileNameAndType);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					this.loadToExcell = false;
					this.closeOpenExport();
				})
				.catch((error) => {
					if (error) {
						this.loadToExcell = false;
						this.showMessages('Ошибка выгрузки, обратитесь к Администратору!', 'error');
					}
				});
		},
		changeYear(year) {
			if (typeof year === 'number') year = String(year);

			this.selectedYear = year;
			let obj = this.params.filters.find((f) => f.fieldName === 'YearStr');

			if (obj) {
				obj.value1 = year.name;
			}

			this.getData(this.params, true);
		},
		columnHasGeneralIndicator(field) {
			let generalIndicators = ['1', '2', '3', '4', '5'];
			return generalIndicators.includes(field);
		},
		showMessages(text, type) {
			this.$toast[type](text, {
				position: 'top-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.6,
				showCloseButtonOnHover: false,
				hideProgressBar: false,
				closeButton: 'button',
				icon: true,
				rtl: false
			});
		},
		closeOpenExport() {
			for (let i = 0; i < this.fieldsDownloadExcell.length; i += 1) {
				this.fieldsDownloadExcell[i].checked = true;
			}

			this.openExport = false;
		}
	},
	mounted() {
		this.resetSort();
		this.getData(this.params, true);
	},
	created() {
		this.getRegions().then((res) => {
			this.fields_sticky[0].list = res.data;
		});

		this.getSystemYearData().then((res) => {
			this.years = res.data.closedYears;
		});
	},
	beforeUpdate() {
		document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.tr1__sticky {
	background-color: #f9fafb;
	top: 0;
	position: sticky;
	z-index: 7;
}
.tr2__sticky {
	background-color: #f9fafb;
	top: 38px;
	position: sticky;
	z-index: 6;
}
.tr3__sticky {
	background-color: #f9fafb;
	top: 140px;
	position: sticky;
	z-index: 6;
}
.sticky-table__header1 {
	left: 48px;
	z-index: 9;
	position: sticky;
	text-align: center;
	background-color: rgba(249, 250, 251);
}
.sticky-table__header2 {
	left: 240px;
	z-index: 8;
	position: sticky;
	text-align: center;
	background-color: rgba(249, 250, 251);
}
.sticky-table__header3 {
	left: 0;
	z-index: 8;
	position: sticky;
	background-color: rgba(249, 250, 251);
}
.sticky-table__row1 {
	background-color: #fff;
	left: 48px;
	position: sticky;
}
.sticky-table__row2 {
	background-color: #fff;
	left: 240px;
	position: sticky;
}
.sticky-table__row3 {
	background-color: #fff;
	left: 0;
	position: sticky;
}

.row-total,
.row-total td {
	background-color: #e2efda;
}
</style>
<style>
li.arrow::before {
	@apply block w-2 h-2 mt-1.5 mr-2 border-b-2 border-l-2 border-gray-400;
	content: '';
	transform: rotate(45deg);
}
.arrow:last-child::before {
	transform: rotate(-135deg);
}

.add-form__selectSingle > .multiselect {
	margin-bottom: 0;
}

.add-form__selectSingle .multiselect__tags {
	font-weight: 400;
	font-size: 14px;
	line-height: 50px;
	min-height: 50px;
	height: auto !important;
	max-width: 100% !important;
	width: 100%;
	border-radius: 10px;
	border: 2px solid #3377ff;
	padding: 0 20px;
	color: #6a6e83;
	background: initial;
	display: flex;
	align-items: center;
}

.add-form__selectSingle .multiselect__tags-wrap {
	display: flex;
	align-items: center;
	height: 50px;
	overflow: hidden;
}

.add-form__selectSingle .multiselect__tag {
	padding: 0;
	color: #6a6e83;
	margin-right: 0;
	background: transparent !important;
	overflow: visible;
}

.add-form__selectSingle .multiselect__tag-icon {
	display: none;
}

.add-form__selectSingle .multiselect__tag:not(:first-child)::before {
	content: ',';
	margin-right: 5px;
}

.add-form__selectSingle .multiselect__option--highlight:after {
	display: none;
}

.add-form__selectSingle .multiselect__select {
	height: 50px;
}

.add-form__selectSingle .multiselect__placeholder {
	margin-bottom: 3px !important;
}

.add-form__selectSingle .multiselect__single {
	line-height: 18px !important;
	font-size: 15px;
	background-color: transparent;
	color: #3377ff;
	font-weight: 700;
}
.add-form__selectSingle .multiselect__select:before {
	border-color: #3377ff transparent transparent !important;
}

.preloader {
	z-index: 10;
	background: rgba(0, 0, 0, 0.09);
}
.custom-w-table-144 {
	max-width: calc(100vw - var(--scrollbar-width) - 144px - 3rem);
}

.custom-w-table-360 {
	max-width: calc(100vw - var(--scrollbar-width) - 360px - 3rem);
}
</style>
